import React, { useEffect } from "react";

import { BrowserRouter as Router, useLocation } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";

import WebclientProvider from "./Libs/Webclient";
import StorageProvider from "./Libs/StorageProvider";
import AuthProvider from "./Libs/AuthProvider";
import AlertProvider from "./Libs/AlertProvider";
import "./AppNew.css";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

const AppRouter = React.lazy(() => import("./AppRouter"));

export default function App() {
    return (
        <React.Suspense fallback={<></>}>
            <StorageProvider>
                <WebclientProvider>
                    <AlertProvider>
                        <AuthProvider>
                            <Router>
                                <ScrollToTop />
                                <AppRouter />
                            </Router>
                        </AuthProvider>
                    </AlertProvider>
                </WebclientProvider>
            </StorageProvider>
        </React.Suspense>
    );
}
